import { useEffect, useState } from "react";

export function useUtag() {
  const [utag, setUtag] = useState<any>();

  useEffect(() => {
    new Promise(resolve => {
      const intervalTimer = setInterval(() => {
        const candidateUtag = (window as any).utag;
        if (candidateUtag && candidateUtag.handler) {
          clearInterval(intervalTimer);
          resolve(candidateUtag);
        }
      }, 100);
    }).then(setUtag);
  }, [])

  return utag;
}